export default __webpack_public_path__ + "static/white-paper-tablet-330bf01b1da85ae8fd77cdf0363d49fc.png";